import ReactDOM from 'react-dom/client';
import App from './main-component/App/App';
import reportWebVitals from './reportWebVitals';
import './css/font-awesome.min.css';
import './css/themify-icons.css';
import './css/flaticon.css';
import './css/animate.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/spacing.min.css';
import './css/leaflet.css';
import './css/menu.css';
import './css/style.css';
import './css/responsive.css';
import { createContext, useState } from 'react';

const root = ReactDOM.createRoot(document.getElementById('root'));
export const LanguageContext = createContext();

const AppWithLanguageProvider = () => {
    const [language, setLanguage] = useState('pl');

    return (
        <LanguageContext.Provider value={{ language, setLanguage }}>
            <App />
        </LanguageContext.Provider>
    );
};

root.render(
    <AppWithLanguageProvider />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
